<template>
    <div >
        <!-- 发票新增按钮 -->
        <el-dialog title="发票新增" v-loading="addLoading" :visible.sync="addDialogVisible" @close="closeAddDialog" :close-on-click-modal="false" width="50%">
            <el-form :model="addInvoiceModel" ref="addInvoiceForm" :rules="rules" status-icon label-position="right">
                <el-row :gutter="20">
                    <el-col>
                        <template>
                            <el-carousel :interval="4000" type="card" height="200px" :loop="false" :autoplay="false"
                                         arrow="always" indicator-position="none" @change="changeInvoice">
                                <el-carousel-item v-for="(item,index) in invoiceUplodList" :key="index">
                                    <el-image style="width: 100%; height: 100%" :src="item.fileUrl"
                                              @click="changeUrl(item.fileUrl,index)">
                                        <p style="position: absolute; bottom: 0px; left: 0; background-color: white; opacity:0.9;display:none;text-align:left;border-radius:4px;"
                                           :class="item.fileId">
                                            {{index}}
                                        </p>
                                    </el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                    </el-col>
                </el-row>
                <div  class="dialog-footer" style="border-top: 1px solid #CECECE;padding-top: 10px; margin-top: 20px">
                    <div class="add-invoice-btn">
                        <el-upload
                            style="display: inline; margin:0 10px"
                            action="'image/*'"
                            accept=".svgz,.pjp,.jfif,.ico,.tiff,.svg,.xbm,.pjpeg,.webp,.tif,.jpeg,.png,.gif,.bmp,.pdf,.jpg"
                            :http-request="addSubmitUpload"
                            :show-file-list="false">
                            <el-button size="small" type="primary" style="padding: 7px 15px">发票上传</el-button>
                        </el-upload>
                    </div>
                </div>
                <el-row :gutter="10" style="border-top: 1px solid #CECECE; padding-top: 20px; margin-top: 10px">
                    <el-col :span="12" :gutter="10">
                        <el-form-item label="发票类型" prop="invoiceType" label-width="120PX">
                            <el-select v-model="addInvoiceModel.invoiceType" @change="invoiceTypeChange" placeholder="请输入发票类型" clearable style="width:80%">
                                <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.label"
                                           :value="item.value" :disabled="item.disabled"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合计金额(不含税)" prop="invoiceAmount" label-width="120PX">
                            <el-input v-model="addInvoiceModel.invoiceAmount" @change="changeAmount" @input="(val)=>{inputChange(val,'invoiceAmount')}" placeholder="请输入合计金额" style="width:80%">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="税率" prop="taxRate" label-width="120PX">
                            <el-input v-model="addInvoiceModel.taxRate" @change="changeAmount" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入税率" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="开票日期" prop="openInvoiceDate" label-width="120PX">
                            <el-date-picker v-model="addInvoiceModel.openInvoiceDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间" style="width:80%"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="纳税人识别号" prop="taxNo" label-width="120PX">
                            <el-input v-model="addInvoiceModel.taxNo" placeholder="请输入纳税人识别号" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="发票代码" v-if="invoiceCodeShow" prop="invoiceCode" label-width="120PX">
                            <el-input v-model="addInvoiceModel.invoiceCode" maxlength="12"
                                      placeholder="请输入发票代码" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="开票单位" prop="openInvoiceCompany" label-width="120PX">
                            <el-input v-model="addInvoiceModel.openInvoiceCompany" placeholder="请输入开票单位" style="width:80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :gutter="20">
                        <el-form-item label="发票号码" prop="invoiceNo" label-width="120PX">
                            <el-input v-model="addInvoiceModel.invoiceNo" placeholder="请输入发票号码" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="发票金额(含税)" prop="amt" label-width="120PX">
                            <el-input v-model="addInvoiceModel.amt" @input="(val)=>{inputChange(val,'amt')}" placeholder="请输入发票金额" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="税额" prop="tax" label-width="120PX">
                            <el-input v-model="addInvoiceModel.tax" @input="(val)=>{inputChange(val,'tax')}" placeholder="请输入税额" style="width:80%"></el-input>
                        </el-form-item>
                        <el-form-item label="验真状态" prop="isChecked" label-width="120PX">
                            <el-select v-model="addInvoiceModel.isChecked" placeholder="请选择验真状态" :disabled="true" clearable style="width:80%">
                                <el-option v-for="item in isCheckedList" :key="item.value" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="购买方名称" prop="buyerName" label-width="120PX">
                            <el-input v-model="addInvoiceModel.buyerName" placeholder="请输入购买方名称" style="width:80%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="border-top: 1px solid #CECECE;padding-top: 10px">
                <el-button @click="closeAddDialog">取 消</el-button>
                <el-button type="primary" @click="saveInvoice" :loading="saveButLoad">保 存</el-button>
            </div>
        </el-dialog>
        <Picture v-if="diaShaow" :data="rowData" :titlePicture="titlePicture" :imgUrl="imgUrl" :diaShaow="diaShaow"
                 @handleStartClose="handleStartClose"></Picture>
    </div>
</template>

<script>
import Picture from '../../../../components/dialog/Picture';
import { twoPointVerify } from '@/modules/lsp-register/constant/formRegular.js';
import { save, onlyUpload } from '../../../../api/invoice';
import { numberAdd } from '../../../../utils/floatUtils';
export default {
    components: { Picture },
    props: {
        addDialogVisible: {
            type: Boolean,
            default: false
        },
        invoiceLists: {
            type: Array
        },
        apApplyObj: {
            type: Object
        }
    },
    data() {
        // 蓝字校验金额必须大于0.红字校验金额小于0
        const validateAmount = (rule, value, callback) => {
            if (value !== '' && value !== undefined) {
                if (this.addInvoiceModel.invoiceType === '15' && value <= 0) { // 蓝字
                    return callback(new Error('全电专票（蓝字）金额必须大于0'));
                } else if (this.addInvoiceModel.invoiceType === '16' && value >= 0) { // 红字
                    return callback(new Error('全电专票（红字）金额必须小于0'));
                } else {
                    return callback();
                }
            }
        };
        return {
            rowData: {},
            currObject: {},
            diaShaow: false,
            addLoading: false,
            saveButLoad: false,
            invoiceCodeShow: false,
            isSaveSuccess: false,
            imgUrl: '',
            url: '',
            titlePicture: '',
            checkShow: '',
            invoiceIndex: 0,
            invoiceUplodList: [],
            requestParamObj: {},
            invoiceTypeList: [
                {
                    value: '01',
                    label: '增值税专用发票',
                    disabled: true
                },
                {
                    value: '04',
                    label: '增值税普通发票',
                    disabled: true
                },
                {
                    value: '08',
                    label: '增值税电子专用发票',
                    disabled: true
                },
                {
                    value: '10',
                    label: '增值税电子普通发票',
                    disabled: true
                },
                {
                    value: '15',
                    label: '全电专票（蓝字）'
                },
                {
                    value: '16',
                    label: '全电专票（红字）'
                },
                {
                    value: '17',
                    label: '全电普票'
                }
            ],
            addInvoiceModel: {
                invoiceType: '15',
                invoiceNo: '',
                openInvoiceDate: '',
                isChecked: '0',
                invoiceAmount: '',
                amt: '',
                taxNo: '',
                buyerName: '',
                taxRate: '',
                tax: '',
                apApplyNo: '',
                invoiceSerial: '',
                openInvoiceCompany: '',
                fee: ''
            },
            rules: {
                openInvoiceCompany: [
                    { required: true, message: '请输入开票单位', trigger: 'blur' }
                ],
                invoiceType: [
                    { required: true, message: '请输入发票类型', trigger: 'blur' }
                ],
                invoiceNo: [
                    { required: true, message: '请输入发票号码', trigger: 'blur' },
                    { min: 20, max: 20, message: '请输入20位发票号码', trigger: 'blur' }
                ],
                openInvoiceDate: [
                    { required: true, message: '请选择日期时间', trigger: 'blur' }
                ],
                isChecked: [
                    { required: true, message: '请选择验真状态', trigger: 'blur' }
                ],
                invoiceAmount: [
                    { required: true, message: '请输入合计金额', trigger: 'blur' },
                    { validator: validateAmount, trigger: 'blur' }
                ],
                amt: [
                    { required: true, message: '请输入发票金额', trigger: 'blur' },
                    { validator: validateAmount, trigger: 'blur' }
                ],
                taxNo: [
                    { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
                    {
                        pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
                        message: '由18位数字或者大写字母组成，但是字母不包括 I、O、Z、S、V',
                        trigger: 'blur'
                    }
                ],
                buyerName: [
                    { required: true, message: '请输入购买方名称', trigger: 'blur' }
                ],
                taxRate: [
                    { required: true, message: '请输入税率', trigger: 'blur' },
                    { pattern: twoPointVerify, message: '税率必须为数值，且最多2位小数', trigger: 'blur' }
                ],
                tax: [
                    { required: true, message: '请输入税额', trigger: 'blur' }
                ],
                invoiceCode: [
                    { required: true, message: '发票代码不能为空', trigger: ['blur', 'change'] },
                    { min: 1, max: 12, message: '发票代码长度最大12', trigger: 'blur' }
                ]
            },
            isCheckedList: [
                {
                    value: '1',
                    label: '验真成功'
                },
                {
                    value: '2',
                    label: '验真失败'
                },
                {
                    value: '0',
                    label: '未验真'
                }
            ]
        };
    },
    mounted() {
        this.saveButLoad = false;
    },
    created() {
        this.currObject = this.apApplyObj;
        this.addInvoiceModel.openInvoiceCompany = this.currObject.suppName;
        this.requestParamObj.businessId = this.currObject.jobId;
        this.requestParamObj.systemSource = '10';
        this.requestParamObj.moduleCode = 'EfApApplyEditor';
        this.requestParamObj.skipCheck = 'Y';
        this.requestParamObj.billNo_AA = this.currObject.apApplyNo;
    },
    methods: {
        inputChange(val, inputName) {
            const newVal = val.replace(/[^\-\d.]/g, '').replace(/\b(0+){2,}/g, '0').replace(/\-{2,}/g, '-')
                .replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            if (inputName === 'invoiceAmount') {
                this.addInvoiceModel.invoiceAmount = newVal;
            } else if (inputName === 'amt') {
                this.addInvoiceModel.amt = newVal;
            } else if (inputName === 'tax') {
                this.addInvoiceModel.tax = newVal;
            }
        },
        closeAddDialog() {
            this.invoiceUplodList = [];
            this.$refs.addInvoiceForm.resetFields();
            this.$emit('closeAddDialog', '');
            if (this.isSaveSuccess) {
                this.$emit('refreshInvoice', '');
                this.isSaveSuccess = false;
            }
        },
        handleStartClose() {
            this.diaShaow = false;
        },
        changeInvoice(index) {
            this.invoiceIndex = index;
        },
        // 新增
        changeUrl(url, index) {
            this.titlePicture = '图片预览';
            this.imgUrl = url;
            this.diaShaow = true;
            this.invoiceIndex = index;
        },
        changeAmount() {
            if (!this.addInvoiceModel.taxRate || !this.addInvoiceModel.invoiceAmount) {
                return;
            }
            this.addInvoiceModel.tax = (this.addInvoiceModel.taxRate * this.addInvoiceModel.invoiceAmount).toFixed(2);
        },
        invoiceTypeChange(val) {
            if (val === '15' || val === '16' || val === '17') {
                this.invoiceCodeShow = false;
            } else {
                this.invoiceCodeShow = true;
            }
        },
        saveInvoice() {
            this.saveButLoad = true;// 加载按钮，防止用户可以多次点击
            const invoiceType = this.addInvoiceModel.invoiceType;
            if (invoiceType !== '15' && invoiceType !== '16' && invoiceType !== '17') {
                this.$message.warning('非全电发票请通过发票上传按钮上传发票');
                this.saveButLoad = false;
            } else if (this.invoiceUplodList === undefined || this.invoiceUplodList === null || this.invoiceUplodList.length <= 0) {
                this.$message.warning('请先上传图片，再保存');
                this.saveButLoad = false;
            } else {
                const flag = this.changeSaveInvoice(this.addInvoiceModel);
                if (flag) {
                    var data = {};
                    var invoiceSaveList = [];
                    const invoiceObj = {};
                    invoiceObj.saveFlag = 'saveFlag';
                    invoiceObj.fileId = this.invoiceUplodList[0].fileId;
                    invoiceObj.fileUrl = this.invoiceUplodList[0].fileUrl;
                    invoiceObj.fileSuffix = this.invoiceUplodList[0].fileSuffix;
                    invoiceObj.invoiceModel = this.addInvoiceModel;
                    invoiceObj.invoiceModel.apApplyNo = this.currObject.apApplyNo;
                    invoiceObj.invoiceModel.invoiceSerial = this.addInvoiceModel.invoiceNo;
                    invoiceObj.invoiceModel.fee = this.addInvoiceModel.invoiceAmount;
                    invoiceSaveList.push(invoiceObj);
                    data.invoiceUploadResTOList = invoiceSaveList;
                    data.params = this.requestParamObj;
                    save(data).then(res => {
                        this.saveButLoad = false;// 释放加载按钮
                        if (res.code === '0') {
                            if (res.data[0].code === '1') {
                                this.$message.warning(res.data[0].message);
                            } else {
                                this.$message.success('保存成功');
                                this.isSaveSuccess = true;
                                this.closeAddDialog();
                            }
                        } else {
                            this.$message.warning('操作失败');
                        }
                    });
                } else {
                    this.saveButLoad = false;
                }
            }
        },
        changeSaveInvoice(item) {
            let validateFlag = false;
            // 蓝字校验金额必须大于0.红字校验金额小于0
            if (item.invoiceType === '15') {
                if (parseFloat(item.invoiceAmount) <= 0) {
                    this.$message.warning('全电专票（蓝字）,合计金额（不含税）必须大于0');
                    return false;
                }
                if (parseFloat(item.amt) <= 0) {
                    this.$message.warning('全电专票（蓝字）,发票金额（含税）必须大于0');
                    return false;
                }
            }
            if (item.invoiceType === '16') {
                if (parseFloat(item.invoiceAmount) >= 0) {
                    this.$message.warning('全电专票（红字）,合计金额（不含税）必须小于0');
                    return false;
                }
                if (parseFloat(item.amt) >= 0) {
                    this.$message.warning('全电专票（红字）,发票金额（含税）必须小于0');
                    return false;
                }
            }
            if (parseFloat(item.amt) !== parseFloat(numberAdd(item.invoiceAmount, item.tax))) {
                this.$message.warning('发票金额(含税) 必须等于 合计金额(不含税) + 税额，请检查');
                return false;
            }
            this.$refs.addInvoiceForm.validate(valid => {
                validateFlag = valid;
            });
            return validateFlag;
        },
        addSubmitUpload(uploadData) {
            const invoiceType = this.addInvoiceModel.invoiceType;
            if (invoiceType !== '15' && invoiceType !== '16' && invoiceType !== '17') {
                this.$message.warning('非全电发票请通过发票上传按钮上传发票');
            } else {
                this.simpleUpload(uploadData);// 简单数据上传
            }
        },
        async simpleUpload(uploadData) { // 发票上传
            this.addLoading = true;
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('businessId', this.currObject.jobId);
            formData.append('systemSource', '10');
            formData.append('moduleCode', 'EfApApplyEditor');
            formData.append('billNo_AA', this.currObject.apApplyNo);
            onlyUpload(formData).then(res => {
                if (res && res.code === '0') {
                    this.invoiceUplodList = [...res.data];
                }
                this.addLoading = false;
            });
        }
    }
};
</script>

<style scoped>

</style>
